import { SMap } from '@client/new/helpers/types';
import { ContentTree } from './extras.domain';

export const selector = <T, T2 extends T>(
  tree: ContentTree,
  contentMap: SMap<T>,
  filter: (v: T) => v is T2,
): T2[] => {
  const walk = (node: ContentTree): T2[] => [
    ...(contentMap[node.id] && filter(contentMap[node.id])
      ? [contentMap[node.id] as T2]
      : []),
    ...(node.items?.flatMap(walk) ?? []),
  ];

  return walk(tree);
};

export const toChildrenMap = (t: ContentTree): SMap<ContentTree[]> => ({
  [t.id]: t.items ?? [],
  ...t.items?.reduce((acc, c) => ({ ...acc, ...toChildrenMap(c) }), {}),
});
